<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="修改负责人"
      @ok="handleSubmit"
    >
      <span>订单负责人的作用是对订单整个流程负责，需跟踪推进订单的进度。</span>
      <a-form
        class="custom-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="负责人">
          <a-select
            v-decorator="['user_id', {
              rules: [
                { required: true, message: '请选择负责人' }
              ]
            }]"
            placeholder="请选择负责人"
            @focus="fetchUserOptions"
            @load="loadingUserOptions"
            @change="handlePhoneNumberChange"
          >
            <a-select-option
              v-for="user in userOptions"
              :key="user.id"
              :value="user.id"
            >
              {{ user.emp_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input
            :disabled="true"
            v-decorator="['phone_number', {
              normalize: this.$lodash.trim
            }]"
            autocomplete="off"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { modifyHeadUser } from '@/api/order'
import { findOrderAuthorityOptions, findUser } from '@/api/user'

export default {
  name: 'HeadUer',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'head_uer' }),
      submitting: false,
      userOptions: [],
      loadingUserOptions: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchUserOptions()
  },
  methods: {
    fetchFormData() {
      if (this.userId !== 0) {
        this.$nextTick(() => {
          this.form.setFieldsValue({ user_id: this.userId })
          findUser(this.userId).then((res) => {
            if (res.code === 0) {
              this.form.setFieldsValue({ phone_number: res.data.phone_number })
            }
          })
        })
      }
    },
    handlePhoneNumberChange(id) {
      this.form.setFieldsValue({ phone_number: undefined })
      if (!id) {
        return
      }
      findUser(id).then((res) => {
        if (res.code === 0) {
          this.form.setFieldsValue({ phone_number: res.data.phone_number })
        }
      })
    },
    fetchUserOptions() {
      this.loadingUserOptions = true
      findOrderAuthorityOptions({ order_id: this.id }).then((res) => {
        if (res.code === 0) {
          this.userOptions = res.data
          this.userOptions.forEach((user) => {
            if (user.id === this.userId) {
              this.fetchFormData()
            }
          })
        }
        this.loadingUserOptions = false
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      if (this.form.getFieldValue('user_id') === this.userId) {
        this.$warning({
          title: '新负责人与原负责人不能相同',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          modifyHeadUser(Object.assign({ order_id: this.id }, values)).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
